function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.17188 9.99999C1.17188 8.42273 1.59266 6.87507 2.38875 5.52437C2.95023 4.57167 3.6875 3.73343 4.55344 3.05328L4.28203 5.2639L5.44516 5.40671L5.945 1.3357L1.87406 0.835815L1.73125 1.99894L3.69324 2.23984C2.77172 2.98992 1.98523 3.90105 1.37922 4.92929C0.476914 6.46023 0 8.21363 0 9.99999C0 12.6711 1.04016 15.1823 2.92891 17.0711C4.8177 18.9598 7.32891 20 10 20V18.8281C7.64191 18.8281 5.42496 17.9098 3.75758 16.2424C2.09016 14.575 1.17188 12.3581 1.17188 9.99999Z",
  fill: "#23335B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6208 15.0707C19.5231 13.5398 20 11.7864 20 10C20 7.32891 18.9598 4.8177 17.0711 2.92891C15.1823 1.0402 12.6711 0 10 0V1.17188C12.3581 1.17188 14.575 2.09016 16.2424 3.75758C17.9098 5.425 18.8281 7.64191 18.8281 10C18.8281 11.5773 18.4073 13.1249 17.6112 14.4756C17.0498 15.4283 16.3125 16.2666 15.4466 16.9467L15.718 14.7361L14.5548 14.5933L14.055 18.6643L18.126 19.1642L18.2688 18.0011L16.3068 17.7602C17.2283 17.0101 18.0148 16.0989 18.6208 15.0707Z",
  fill: "#23335B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5858 10.4143L8.34279 9.17138L7.51416 10L9.5858 12.0716L12.486 9.17138L11.6574 8.34274L9.5858 10.4143Z",
  fill: "#23335B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10 4.72656C7.09223 4.72656 4.72656 7.09223 4.72656 10C4.72656 12.9078 7.09223 15.2734 10 15.2734C12.9078 15.2734 15.2734 12.9078 15.2734 10C15.2734 7.09223 12.9078 4.72656 10 4.72656ZM10 14.1016C7.7384 14.1016 5.89844 12.2616 5.89844 10C5.89844 7.7384 7.7384 5.89844 10 5.89844C12.2616 5.89844 14.1016 7.7384 14.1016 10C14.1016 12.2616 12.2616 14.1016 10 14.1016Z",
  fill: "#23335B"
});

var SvgExerciseCompletion = function SvgExerciseCompletion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExerciseCompletion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exercise-completion.77a5b208.svg";
export { ForwardRef as ReactComponent };